(function () {
  var currentScript = document.currentScript;
  var targetHandles = {
    "returns-warranties-for-kids-baby-mattresses": true
  };

  function getPageHandle() {
    var parts = window.location.pathname.split("/").filter(Boolean);
    return parts[parts.length - 1] || "";
  }

  function shouldRunCleanup() {
    return Boolean(targetHandles[getPageHandle()]);
  }

  function removeNestBlogCards() {
    if (!shouldRunCleanup()) return;

    document.querySelectorAll("[data-faq-library-main] .faq-library-card").forEach(function (card) {
      var heading = card.querySelector("h2");
      var headingText = heading ? heading.textContent.replace(/\s+/g, " ").trim() : "";

      if (/^Nest Blog:/i.test(headingText)) {
        card.remove();
      }
    });
  }

  function watchForNestBlogCards() {
    if (!shouldRunCleanup()) return;

    var main = document.querySelector("[data-faq-library-main]");
    if (!main || main.dataset.nestBlogCleanupObserver === "true") return;

    main.dataset.nestBlogCleanupObserver = "true";
    var observer = new MutationObserver(removeNestBlogCards);
    observer.observe(main, { childList: true, subtree: true });
    removeNestBlogCards();
  }

  function getBaseAssetUrl() {
    if (!currentScript || !currentScript.src) return "";

    var url = new URL(currentScript.src, window.location.origin);
    url.pathname = url.pathname.replace(/faq-library-auto\.js$/, "faq-library-auto-base-20260629.js");
    url.search = "";
    return url.toString();
  }

  function loadBaseRenderer() {
    var baseUrl = getBaseAssetUrl();
    if (!baseUrl) return;

    var script = document.createElement("script");
    script.src = baseUrl;
    script.async = false;
    script.onload = function () {
      removeNestBlogCards();
      watchForNestBlogCards();
      [100, 500, 1500].forEach(function (delay) {
        window.setTimeout(removeNestBlogCards, delay);
      });
    };

    (currentScript && currentScript.parentNode ? currentScript.parentNode : document.head).appendChild(script);
  }

  loadBaseRenderer();
})();
